import Vue from 'vue';
Vue.prototype.$showNotification = function (title, desc, duration, icon) {
    this.$notification.open({
        message: title,
        description: desc,
        duration: duration,
        icon: icon
    });
};
